import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserProvider, useUserContext } from './contexts/UserContext';
import { DashboardProvider } from './contexts/DashboardContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Componente Wrapper para aplicar a key ao DashboardProvider
const KeyedDashboardProvider = () => {
  const { accountSwitchTrigger } = useUserContext();

  return (
    <DashboardProvider key={accountSwitchTrigger}>
      <App />
    </DashboardProvider>
  );
};

root.render(
  <React.StrictMode>
    <Router>
      <UserProvider>
        <KeyedDashboardProvider />
      </UserProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();